var app = app ||  {};
app.pcc = app.pcc || {};

;(function(namespace, $){

  var Pcc = function() {

    function CadastraPcc() {
      var validate_form = new lcssafira.form.ValidateForm('form-pcc');
    }

    function BuscaPcc() {
      $('#form-busca-pcc').submit(function(event) {
        event.preventDefault();
        var data = $(this).serialize();
        app.datatable.initDataTable(true, false, '?' + data, 'pcc', '/pcc/consultar');
      });
    }

    function loadCategories() {
      var btn_categoria,
          table,
          id_categorie,
          el_table_name,
          el_table_col,
          el_id_categoria,
          el_select_id;

      btn_categoria = $('.categorias');
      el_table_name = $('#table-name');
      el_table_col = $('#table-col');
      el_id_categoria = $('#id-categoria');

      btn_categoria.bind('change', function(event) {
        _self = $(this);
        table = _self.attr('data-table');
        id_categorie = _self.val();
        el_select_id = _self.attr('id');

        if(id_categorie != '') {
          if(table != '')

          el_table_name.val(table);
          el_id_categoria.val(id_categorie);
          el_table_col.val(el_select_id);
        }
        else {
          el_table_name.val('categoria');
          el_id_categoria.val('');
          el_table_col.val('');
        }

        if(table == '')
          return false

        app.ajaxrequest.initialize('/categorias-mkt/' + table, 'get', 'json', { table: table, id_categoria: id_categorie, 'where_colum' : el_select_id }, app.pcc.responseCategories);
      });
    }

    function responseCategories(data) {
      var selects_holder,
          el_select_id,
          next_select;

      selects_holder = $('#categories-row');
      el_select_id = $('#' + data[1]['table']);
      el_select_id.html('');

      $(el_select_id).parents('.col').nextAll().addClass('hide');
      $(el_select_id).parents('.col').nextAll().find('select').html('');

      if(data[0].length > 0)
        $(el_select_id).parents('.col').removeClass('hide');
      
      $.each(data[0], function(index, val) {
        el_select_id.append('<option value="' + val.id_categoria + '">' + val.nome_categoria + '</option>');
      });

      el_select_id.selectpicker('refresh');
    }

    function addVencimentos() {
      var el_row_vencimentos,
          el_holder_vencimentos,
          btn_add_vencimento;

      el_row_vencimentos = $('#row-vencimentos');
      el_holder_vencimentos = $('.holder-vencimentos:first-child');
      btn_add_vencimento = $('#add-vencimento');

      btn_add_vencimento.bind('click', function(event) {
        el_holder_vencimentos
        .clone()
        .appendTo('#row-vencimentos');
        $('.holder-vencimentos:last-child').find('span').removeClass('icon-add');
        $('.holder-vencimentos:last-child').find('span')
        .addClass('remove-vencimento')
        .addClass('icon-close');
        $('.holder-vencimentos:last-child input')
        .removeClass('valid')
        .removeAttr('aria-invalid')
        .val('');

        app.main.unmasks();
        app.main.masks();
        app.main.dinamicDatePicker('.datetimepicker');
      });
    }

    function listenerCheckBvAgencia() {
      $('#bv-agencia').on('switchChange.bootstrapSwitch', function(event, state) {
          showInputsBvAgencia(state);
      });
    }

    function showInputsBvAgencia(state) {
      var el_wrapper_bv,
          col_total_geral;
      
      el_wrapper_bv = $('.wrapper-inputs-bv');
      col_total_geral = $('.col-total-geral');

      if(state) {
        el_wrapper_bv.removeClass('hide');
        $('body').off('keyup','.val-unitario-item', calculaValItens);
        col_total_geral.removeClass('col-lg-offset-7 col-md-offset-7');
        // col_total_geral.addClass('col-lg-offset-6 col-md-offset-6');
        calculaBvAgencia();
        $('.val-unitario-item').trigger('change');

      }
      else {
        el_wrapper_bv.addClass('hide');
        col_total_geral.addClass('col-lg-offset-7 col-md-offset-7');
        // col_total_geral.removeClass('col-md-offset-6 col-lg-offset-6');
        $('body').off('keyup','.val-unitario-item', calculaBvAgencia);
        calculaValItens();
      }
    }

    function calculaBvAgencia() {
      var el_custo_bruto,
          el_custo_liquido,
          qtd_item,
          el_comissao_agencia;

      el_custo_bruto = '.val-unitario-item';

      $(el_custo_bruto).bind('change', function(event) {
        _self = $(this);
        qtd_item = _self.parents('.holder-vencimentos').find('.qtd-item').val();
        // el_custo_liquido = _self.parents('.holder-vencimentos').find('.val-total-item');
        el_custo_liquido = $('.total-geral');
        // el_comissao_agencia = _self.parents('.holder-vencimentos').find('.comissao');
        el_comissao_agencia = $('#comissao');

        custo_bruto = (_self.val() == '') ? 0 : _self.val();
        custo_bruto = (el_custo_liquido.val() == '') ? 0 : el_custo_liquido.val();
        custo_bruto = app.main.formatMoneyToBd(custo_bruto);
        custo_bruto = parseFloat(custo_bruto);

        perc_comissao_agencia = 20;
        comissao_agencia = (custo_bruto) * (perc_comissao_agencia/100);
        // custo_liquido = (qtd_item * custo_bruto) - comissao_agencia;

        el_comissao_agencia.val(app.main.formatReal(comissao_agencia, false));
        // el_custo_liquido.val(app.main.formatReal(custo_liquido, false));
        somaGeralItens();
      });
    }

    function calculaValItens() {
      var el_qtd,
          el_total_item,
          qtd_item,
          val_un_item,
          val_tot_item,
          el_bv_agencia,
          el_unitario_item;

      el_qtd = $('.qtd-item');
      el_unitario_item = $('.val-unitario-item');
      $('body').on('keyup', '.val-unitario-item', function(event) {
        qtd_item = $(this).parents('.holder-vencimentos').find('.qtd-item').val();
        val_un_item = ($(this).val() != '') ? app.main.formatMoneyToBd($(this).val()) : 0;
        val_un_item = parseFloat(val_un_item);
        
        el_total_item = $(this).parents('.holder-vencimentos').find('.val-total-item');
        val_tot_item = qtd_item * val_un_item;
        el_total_item.val(app.main.formatReal(val_tot_item, false));
        somaGeralItens();
      });
      $('.val-unitario-item').trigger('keyup');
    }

    function somaGeralItens() {
      var el_total_item,
          el_total_geral,
          total_geral;

      el_total_item = $('.val-total-item');
      el_total_geral = $('.total-geral');
      total_geral = 0;

      el_total_item.each(function(index, el) {
        val_tot_item = $(el).val();
        val_tot_item = app.main.formatMoneyToBd(val_tot_item);
        val_tot_item = parseFloat(val_tot_item);
        total_geral+= val_tot_item;
        el_total_geral.val(app.main.formatReal(total_geral,false));
      });
    }

    function toogleInputDataPersonalizada() {
      var el_check_dt_negociacao,
          holder_dt_negociacao;

      el_check_dt_negociacao = $('#check-dt-negociacao');
      holder_dt_negociacao = $('.holder-dt-negociacao');

      el_check_dt_negociacao.on('switchChange.bootstrapSwitch', function(event, state) {
          
          if(state)
            holder_dt_negociacao.removeClass('hide');
          else
            holder_dt_negociacao.addClass('hide');
      });
    }

    function abrePcc() {
      $('table').on('click', '.pcc-col', function(event) {
        event.preventDefault();
        id_pcc = $(this).parents('tr').find('.cod').text();
        app.ajaxrequest.initialize('/pcc/consultar/' + id_pcc, 'get', 'json', '', app.pcc.responsePcc);
        /* Act on the event */
      });
    }

    function liberaPcc() {
      var message,
          confirm_modal,
          id_pedido;

      // $('.label-success').bind('click', function(event) {
        id_pedido = $(this).attr('data-id-pedido');
        message = "Tem certeza que deseja abrir o PCC ";
        confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.label-success', message, 'confirm-edit');
      // });
    }

    function responseModalLiberaPcc(id_pcc)
    {
      app.ajaxrequest.initialize('/pcc/liberapcc/' + id_pcc, 'get', 'json', '', app.pcc.responseLiberaPcc);
    }

    function responseSignPcc(data) {

      var msg = {
        codigo : 1,
        mensagem : ''
      };

      switch (data) {
        case 2:
          msg.mensagem = 'OS já assinada anteriormente';
          break;
        case 1:
          msg.mensagem = "OS assinada.";
          break;

        default:
          msg.mensagem = 'Não foi possível assinar a OS.';
      }
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('', msg, 'alert');
    }


    function responseLiberaPcc(data)
    {
      app.datatable.initDataTable(true, false, '', 'pcc', '/pcc/consultar');
    }

    function responsePcc(data) {

      var table_vencimentos,
          table_itens,
          holder_contatos,
          holder_contatos_cliente,
          logged_in_user,
          quem_assina

      table_vencimentos = $('#table-vencimentos tbody');
      table_itens = $('#table-itens tbody');
      holder_contatos = $('#holder-contatos');
      holder_contatos_cliente = $('#holder-contatos-cliente');

      table_vencimentos.html('');
      table_itens.html('');
      holder_contatos.html('');
      holder_contatos_cliente.html('');

      $('.bd-holder').each(function(index, el) {
        column = $(this).attr('data-column');

        if(data[0][column] == '' || data[0][column] == null){
          
          if(column == 'id_pedido_compras')
            $(this).parent().css('display', 'none');
    
          $(el).text('');
        }
        else {

          if(column == 'id_pedido_compras')
            $(this).parent().css('display', 'block');

          if(data[0]['id_status'] !=2)
            $('.custo-final').css('display', 'none');
          else
            $('.custo-final').css('display', 'inline-block');

          $(el).html(data[0][column]);
        }
      });
      $.each(data[0]['itens'], function(index, val) {
         table_itens.append(
          '<tr>' +
            '<td>' + val.item + '</td>' +
            '<td>' + val.qtd + '</td>' +
            '<td>' + val.valor + '</td>' +
            '<td>' + val.valor_total + '</td>' +
          '</tr>'
          );
      });

      $.each(data[0]['vencimentos'], function(index, val) {
         table_vencimentos.append(
          '<tr>' +
            '<td>' + val.dt_vencimento + '</td>' +
            '<td>' + val.valor + '</td>' +
          '</tr>'
          );
      });

      $.each(data[0]['contatos_fornecedor'], function(index, val) {
         holder_contatos.append(
          '<span class="block small">Contato: ' + val.nome_contato_fornecedor + '</span>' + 
          '<span class="block small">Tel.: ' + val.tel_contato_fornecedor + '</span>' + 
          '<span class="block small">E-mail: ' + val.email_contato_fornecedor + '</span>'
          );
      });

      $.each(data[0]['contatos_cliente'], function(index, val) {
         holder_contatos_cliente.append(
          '<span class="block small">Contato: ' + val.nome_contato_cliente + '</span>' + 
          '<span class="block small">Tel.: ' + val.tel_contato_cliente + '</span>' + 
          '<span class="block small">E-mail: ' + val.email_contato_cliente + '</span>'
          );
      });

      logged_in_user = data[0]['logged_in_user_id'];
      logged_in_user = logged_in_user.toString();
      quem_assina = data[0]['quem_assina'] ? data[0]['quem_assina'].split(',') : [];

      if($.inArray(logged_in_user, quem_assina) === -1) {
        $('.btn-sign-holder').hide();
      }

      $('.btn-print').attr('href', url + '/pcc/imprimir/' + data[0]['id_pedido']);

      $('.btn-sign').on('click', function(event){
        event.preventDefault();
        app.ajaxrequest.initialize('/pcc/sign/' + data[0]['id_pedido'], 'post', 'json', '', app.pcc.responseSignPcc);
      });

      $('.btn-pdf').attr('href', url + '/pcc/pdf/' + data[0]['id_pedido']);
      $('#modal-pcc').modal();
    }

    function closeModalPCC() {
      $('#modal-pcc').on('hidden.bs.modal', function (e) {
        $('.iframe-print').remove();
      });
    }

    function removeVencimentos() {
      var btn_remove_vencimento;

      btn_remove_vencimento = '.remove-vencimento';

      $('body').on('click', btn_remove_vencimento, function(event) {
        $(this).parents('.holder-vencimentos, .holder-vencimentos-pcc').remove();
        somaGeralItens();
      });
    }

    function generateVencimentos() {
      var el_qtd_venc,
          el_val,
          el_row_vencimentos;

      el_qtd_venc = $('#qtd-vencimentos');
      el_row_vencimentos = $('#row-vencimentos-pcc');

      el_qtd_venc.bind('keyup', function(event) {
        el_val = $(this).val();
        el_row_vencimentos.html('');
        app.main.unmasks();

        for (var i = 1; i <= el_val; i++) {
          el_row_vencimentos.append(
            '<div class="col-md-2">' + 
                '<div class="form-group">' +
                    '<label for="qtd" class="block">' + i + 'º Vencimento</label>' +
                    '<input type="text" class="form-control dt-vencimento data" name="dt-vencimento[]"><br>' +
                    '<div class="input-group">' +
                        '<div class="input-group-addon">R$</div>' +
                        '<input type="text" class="form-control val-vencimento money" name="val-vencimento[]">' +
                    '</div>' +
                '</div>' +
            '</div>'
          );
        }

        app.main.masks();
      });
    }

    function print() {
      $('.btn-print').bind('click', function(event) {
        event.preventDefault();
        $("<iframe>")
        .attr("src", $(this).attr('href'))
        .attr("class", 'iframe-print')
        .appendTo("body");
      });
    }

    function _construct() {
      CadastraPcc();
      BuscaPcc();
      abrePcc();
      loadCategories();
      addVencimentos();
      removeVencimentos();
      listenerCheckBvAgencia();
      liberaPcc();
      // calculaBvAgencia();
      toogleInputDataPersonalizada();
      calculaValItens();
      print();
      closeModalPCC();
      generateVencimentos();
      showInputsBvAgencia(false);

      app.datatable.initDataTable(false, true, '', 'pcc', '/pcc/consultar');
      var message = "A remoção de um pcc implica na exclusão de qualquer dado vinculado a ele.";
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.remove-pcc', message);
      // $('.categorias').trigger('change');
    }

    namespace.responseCategories = responseCategories;
    namespace.responseModalLiberaPcc = responseModalLiberaPcc;
    namespace.responseLiberaPcc = responseLiberaPcc;
    namespace.responsePcc = responsePcc;
    namespace.responseSignPcc = responseSignPcc;
    _construct();

  };

  var main = new Pcc();

})(app.pcc, jQuery);


